export const paymentStatus = {
  pending: 1,
  approved: 2,
  rejected: 3,
};
